module.exports = __webpack_public_path__ + "img/db-alert.6ac72610.svg";